export default __webpack_public_path__ + "static/media/call-phone-green.9374bf38.svg";